import { createConfirmation } from 'react-confirm';
import OptionsDialogComponent from '../components/misc/OptionsDialog';

// Taken from the react-confirm manual: https://www.npmjs.com/package/react-confirm

// create confirm function
const confirmation = createConfirmation(OptionsDialogComponent);

// This is optional. But I recommend to define your confirm function easy to call.
export function optionsDialogGeneral(title, text, choices, options = {}) {
    // You can pass whatever you want to the component. These arguments will be your Component's props
    return confirmation({ title, text, choices, options, ...options });
}

// A version of the confirm function, which is a little easier to use in the normal use-case (We don't have to write ".then(...)").
export function optionsDialog(title, text, choices, onOk, onCancel = null, options = {}) {
    if (onCancel == null) onCancel = () => {};
    return optionsDialogGeneral(title, text, choices, options).then(onOk, onCancel);
}



// WEBPACK FOOTER //
// ./src/client/src/utils/optionsDialog.js